import type { Offset } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useDispatch, useSelector } from 'react-redux'

import { RequestActions } from '@/store'
import { getId } from '@/utils/temporaryHelper'
import { createNewAttach } from './actions'

const useAttachFile = () => {
  const dispatch = useDispatch()
  const tabId = useSelector(migrationProjectSelector.getActiveOrFirstTabId)

  const handleFile = (file: File, offset: Offset) => {
    const attachId = getId()
    const fileId = getId()

    dispatch(createNewAttach(attachId, fileId, offset, tabId))

    dispatch(
      RequestActions.attachFile({
        attachId,
        file,
        fileId,
      })
    )
  }

  return { handleFile }
}

export default useAttachFile
